const validCache = new Map<string, boolean>();

export const checkValidImage = (src: string): Promise<boolean> => {
  const cachedValue = validCache.get(src);
  if (cachedValue === true) {
    return Promise.resolve(true);
  } else if (cachedValue === false) {
    return Promise.resolve(false);
  }
  
  return new Promise<boolean>((resolve) => {
    const img = new Image();
    img.onload = () => {
      validCache.set(src, true);
      resolve(true);
    }
    img.onerror = () => {
      validCache.set(src, false);
      resolve(false);
    }
    img.src = src;
  })
}
